import Month from '../pages/personal/Month.vue'
import Area from '../pages/personal/Area.vue'
import Router from "vue-router";
import store1 from "../store/index.js";
import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  },
  {
    path: '/areas',
    name: 'Areas',
    component: Area,
    meta: { bodyClass: 'landing-page' }
  },
  {
    path: `/all/articles`,
    name: 'Article',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/articles/:year`,
    name: 'Article1',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/articles/bycat/:catid`,
    name: 'Article2',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/articles/search/:type/:term`,
    name: 'Article5',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/articles/:year/:month1`,
    name: 'Article3',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/articles/:year/:month1/:day`,
    name: 'Article4',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/all/article-details/:id`,
    name: 'ArticleDetails',
    component: () => import(/* webpackChunkName: "articledetails" */ "../pages/common-apps/ArticleDetails.vue"),
    // component: ArticleDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  }
] // to comment Landing route when using on dev mode

const personalRoutes = [
  {
    path: '/fin/month/:month1/:year',
    name: 'Month',
    component: Month,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/phy/shopping',
    name: 'Shopping',
    component: () => import(/* webpackChunkName: "shopping" */ "../pages/personal/Shopping.vue"),
    // component: Emotion,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/tickets',
    name: 'Ticket',
    component: () => import(/* webpackChunkName: "ticket" */ "../pages/personal/Ticket.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/tickets/:id',
    name: 'Ticket1',
    component: () => import(/* webpackChunkName: "ticketdetails" */ "../pages/personal/TicketDetails.vue"),
    // component: TicketDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },

  {
    path: '/voc/books',
    name: 'Books',
    component: () => import(/* webpackChunkName: "books" */ "../pages/personal/Books.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/books/:id',
    name: 'BookDetails',
    component: () => import(/* webpackChunkName: "bookdetails" */ "../pages/personal/BookDetails.vue"),
    // component: BookDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/nuskinlist',
    name: 'Nu Skin List',
    component: () => import(/* webpackChunkName: "nuskinlist" */ "../pages/personal/NuskinList.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/nuskincategory/:id',
    name: 'Nu Skin Category',
    component: () => import(/* webpackChunkName: "nuskincategory" */ "../pages/personal/NuSkinCategory.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/nuskinarticle/:id',
    name: 'Nu Skin Article',
    component: () => import(/* webpackChunkName: "nuskincategory" */ "../pages/personal/NuSkinArticle.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/quotes',
    name: 'Quote',
    component: () => import(/* webpackChunkName: "quote" */ "../pages/personal/Quote.vue"),
    // component: Quote,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },

  {
    path: '/voc/movies',
    name: 'Movie',
    component: () => import(/* webpackChunkName: "movies" */ "../pages/personal/Movies.vue"),
    // component: Movies,
    // beforeEnter: ifAuthenticated,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/food',
    name: 'Food',
    component: () => import(/* webpackChunkName: "food" */ "../pages/personal/Food.vue"),
    // component: Food,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/fin/timeline',
    name: 'Timeline',
    component: () => import(/* webpackChunkName: "timeline" */ "../pages/personal/Timeline.vue"),
    // component: Timeline,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/voc/songs',
    name: 'Songs',
    component: () => import(/* webpackChunkName: "songs" */ "../pages/personal/Songs.vue"),
    // component: Songs,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
   {
    path: '/soc/chat',
    name: 'Chat',
    component: () => import(/* webpackChunkName: "chat" */ "../pages/personal/Chat.vue"),
    // component: Chat,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },

  {
    path: '/all/links',
    name: 'Links',
    component: () => import(/* webpackChunkName: "links" */ "../pages/personal/Links.vue"),
    // component: Links,
    meta: { bodyClass: 'body-bg-white', requiresAuth: true }
  },

  {
    path: '/all/planning2',
    name: 'Planning New',
    component: () => import(/* webpackChunkName: "goals" */ "../pages/personal/Planning2.vue"),
    // component: Goals,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/wishlist',
    name: 'Wishlist',
    component: () => import(/* webpackChunkName: "goals" */ "../pages/personal/Wishlist.vue"),
    // component: Goals,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/men/goals2',
    name: 'Goals 2',
    component: () => import(/* webpackChunkName: "goals2" */ "../pages/personal/Goals2.vue"),
    // component: Goals2,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/life-story-timeline',
    name: 'LifeStoryTimeline',
    component: () => import(/* webpackChunkName: "lifestorytimeline" */ "../pages/personal/LifeStoryTimeline.vue"),
    // component: LifeStoryTimeline,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/phy/health',
    name: 'Health',
    component: () => import(/* webpackChunkName: "health" */ "../pages/personal/Health.vue"),
    // component: Health,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ "../pages/personal/Settings.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },

  {
    path: '/spi/afteridie',
    name: 'After I Die',
    component: () => import(/* webpackChunkName: "afteridie" */ "../pages/personal/AfterIDie.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/reviews',
    name: 'Reviews',
    component: () => import(/* webpackChunkName: "review" */ "../pages/personal/Review.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/all/reviews/:id',
    name: 'ReviewDetails',
    component: () => import(/* webpackChunkName: "reviewdetails" */ "../pages/personal/ReviewDetails.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/men/method/:id',
    name: 'Demartini Method',
    component: () => import(/* webpackChunkName: "method" */ "../pages/personal/MethodDetails.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/men/human-actions',
    name: 'Human actions',
    component: () => import(/* webpackChunkName: "humanactions" */ "../pages/personal/HumanActions.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
]

const routes = baseRoutes.concat(personalRoutes)

const routerPersonal = new Router({
  routes,
  base: 'per',
  mode: 'history'
})

routerPersonal.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})
export default routerPersonal